import { motion } from "framer-motion";
import { SITE } from "@/config/site";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { introDelay } from "./Motion";

export const WhatsAppFloat = () => (
  <motion.a
    href={SITE.whatsappHref}
    target="_blank"
    rel="noreferrer"
    aria-label="Prenota su WhatsApp"
    data-testid="whatsapp-float-button"
    initial={{ opacity: 0, scale: 0.6, y: 30 }}
    animate={{ opacity: 1, scale: 1, y: 0 }}
    transition={{ delay: introDelay() + 0.8, type: "spring", stiffness: 260, damping: 18 }}
    className="group fixed z-[60] bottom-5 left-5 sm:left-auto sm:bottom-8 sm:right-8 flex items-center gap-2 rounded-full bg-[#25D366] text-[#0D0D0F] p-3.5 sm:pl-4 sm:pr-6 sm:py-3.5 shadow-[0_18px_45px_-10px_rgba(37,211,102,0.65)] transition-[transform,background-color] duration-300 hover:-translate-y-1 hover:bg-[#2BE070]"
  >
    <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25 pointer-events-none" />
    <WhatsAppIcon className="relative w-7 h-7 transition-transform duration-300 group-hover:-rotate-12" />
    <span className="relative hidden sm:inline font-bold">Prenota su WhatsApp</span>
  </motion.a>
);
